<template>
  <div class="container">
    <!-- 头部 -->
    <header_auth/>

    <!-- 轮播 -->
    <div class="carousel">
      <div class="nav w">
        <div class="login">
          <div class="login-container" v-loading="loading">
            <el-tabs v-model="form.login_type">
              <el-tab-pane label="账号登录" name="">
                <el-form
                    ref="form"
                    :model="form"
                    label-width="0"
                    style="max-width:500px"
                    :rules="rules"
                    class="form"
                    autocomplete="on"
                    v-show="!profile.id"
                >
                  <el-form-item prop="mobile">
                    <el-input
                        v-model="form.mobile"
                        placeholder="请输入手机号码"
                        clearable
                        @keyup.enter.native="onSubmit"
                        @focus="message = ''"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                        v-model="form.password"
                        placeholder="请输入登录密码"
                        type="password"
                        clearable
                        @keyup.enter.native="onSubmit"
                        @focus="message = ''"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                        type="primary"
                        @click="onSubmit"
                        :loading="submitting"
                        class="submit-btn"
                        :disabled="!form.mobile || !form.password"
                    >立即登录
                    </el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="手机登录" name="sms">
                <el-form
                    ref="form"
                    :model="form"
                    label-width="0"
                    style="max-width:500px"
                    :rules="rules"
                    class="form"
                    autocomplete="on"
                    v-show="!profile.id"
                >
                  <el-form-item prop="mobile">
                    <el-input
                        v-model="form.mobile"
                        placeholder="请输入手机号码"
                        clearable
                        @keyup.enter.native="on_submit2"
                        @focus="message = ''"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-col :span="15">
                      <el-form-item prop="captcha_sms">
                        <el-input
                            placeholder="请输入短信验证码"
                            v-model="form.captcha_sms"
                            clearable
                            autocomplete="new-password"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" style="float: right;">
                      <el-form-item style="height:40px;">
                        <el-button
                            ref="get_captcha"
                            class="btn-sms"
                            type="primary"
                            @click="on_captcha"
                            :disabled="count_down > 0 || !form.mobile"
                        >
                          {{ count_down ? "请等待" + count_down + "秒" : "获取验证码" }}
                        </el-button>
                      </el-form-item>
                    </el-col>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                        type="primary"
                        @click="on_submit2"
                        :loading="submitting"
                        class="submit-btn"
                        :disabled="!form.mobile || !form.captcha_sms"
                    >立即登录
                    </el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>

            <div class="action" v-show="!profile.id">
              <a class="link" href="/signup">注册帐号</a>
              <a class="link" href="/forgot_password">忘记密码？</a>
            </div>

            <!--已经登录成功-->
            <div class="login-profile" v-show="profile.id">
              <img :src="profile.avatar" class="avatar"/>

              <div class="detail">欢迎回来：{{ profile.name }}</div>

              <div class="op">
                <a class="link" href="/">用户中心</a>
                <a class="link" target="_blank" href="/recharge">充值中心</a>
                <a class="link" @click="handleLoginout">注销登录</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <global-footer/>
  </div>
</template>

<script>
import * as Cookies from "js-cookie";
import header_auth from "../components/header_auth";

export default {
  components: {header_auth},
  data() {
    return {
      submitting: false,
      url_callback: "/",
      count_down: 0,
      form: {
        login_type: "",
        mobile: "",
        device: "pc",
        password: "",
        captcha: "",
      },
      loading: false,
      rules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    isLogin() {
    },
  },
  created() {
    const query = this.$route.query;
    this.url_callback = query["url_callback"] || this.url_callback;

    this.form.mobile = Cookies.get("remember_account");
  },
  methods: {
    handleLoginout() {
      this.loading = true;
      this.$http
          .post("/auth/logout")
          .then((response) => {
            if (response.success) {
              window.location.reload();
            }
          })
          .catch()
          .then(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.on_ok();
          // this.$event_bus.$emit("captcha_verify", (e) => {
          //     this.form.captcha = e;
          //     this.on_ok();
          // });
        } else {
          return false;
        }
      });
    },
    on_submit2() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.on_ok();
        } else {
          return false;
        }
      });
    },
    on_captcha() {
      if (this.form.mobile == "") {
        this.$alert("手机号码不能为空", "输入错误", {
          type: "error",
        });
        return false;
      }

      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.mobile)) {
        this.$alert("手机号码格式错误", "输入错误", {
          type: "error",
        });

        return false;
      }

      this.get_captcha();
      // this.$event_bus.$emit("captcha_verify", (e) => {
      //     this.form.captcha = e;
      //     this.get_captcha();
      // });
    },
    get_captcha() {
      this.count_down = 60;

      let loading_instance = this.$loading({
        text: "正在发送验证码...",
      });

      this.$http
          .post("auth/captcha/sms", {
            mobile: this.form.mobile,
            scope: "sms_login",
            captcha: this.form.captcha,
          })
          .then((response) => {
            if (response.success) {
              this.$alert("请查看手机短信验证码", "验证码发送成功", {
                confirmButtonText: "确定",
                type: "success",
                callback: (action) => {
                },
              });

              var timer = setInterval(() => {
                this.count_down--;
                if (this.count_down == 0) {
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.count_down = 0;
              this.$alert(response.message, "验证码发送失败", {
                confirmButtonText: "确定",
                type: "error",
              });
            }
          })
          .catch(() => {
            this.count_down = 0;
          })
          .then(() => {
            loading_instance.close();
          });
    },
    on_ok() {
      this.submitting = true;
      this.$http
          .post("auth/authenticate", {
            ...this.form,
          })
          .then((response) => {
            if (response.success) {
              Cookies.set("remember_account", this.form.mobile);

              if (this.url_callback) {
                window.top.location.href = decodeURI(this.url_callback);
              } else {
                window.location.reload();
              }
            } else {
              this.$msgbox({
                title: "登录失败",
                message: response.message,
                type: "error",
              });
            }
          })
          .catch()
          .then(() => {
            this.submitting = false;
          });
    },
  },
};
</script>

<style scoped lang="less">
.w {
  width: 1200px;
  margin: 0 auto;
}

.carousel {
  width: 100%;
  height: calc(100vh - 507px);
  min-height: 500px;
  background: url("https://assets.711.cn/assets/images/banner/login.jpg") no-repeat top center;
}

.carousel .nav .login .titles {
  margin-bottom: 17px;
}

.carousel .nav .login a.now {
  border-bottom: 3px solid #ff622b;
  color: #555555;
}

.carousel .nav .login form input[name="code"] {
  width: 50%;
}

.carousel .nav .login form button {
  width: 100%;
}

.li {
  margin-left: 280px;
}

.login {
  width: 300px;
  float: right;
  border-radius: 5px;
  margin-top: 70px;
  padding: 12px;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;

  .login-container {
    /deep/ .el-tabs__header {
      margin-bottom: 36px;
    }

    /deep/ .el-tabs__item {
      width: 50%;
      text-align: center;
    }

    /deep/ .el-tabs__item {
      font-size: 18px;
    }

    .title {
      font-size: 18px;
      text-align: center;
      margin-bottom: 24px;
    }

    .submit-btn {
      margin-top: 24px;
    }

    .action {
      a {
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        display: inline-block;
        margin-right: 12px;
      }
    }

    .login-profile {
      text-align: center;

      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
        margin-left: auto;
        margin-right: auto;
      }

      .detail {
        margin: 48px auto;
        text-align: center;
      }

      .op {
        display: flex;
        justify-content: space-around;
      }
    }
  }
}
</style>
